
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offices/office/[id]",
      function () {
        return require("private-next-pages/offices/office/[id].tsx");
      }
    ]);
  